<template>
  <div class="labels-container">
    <w-tag
      class="label-item"
      v-for="(label, index) in groupStore.state.allLabels"
      :key="index"
      :model-value="label"
      @click="setLabel(label)"
      :bg-color="label === groupStore.state.label ? 'primary-light2' : 'primary'"
      dark
      lg
    >
      {{ label }}
    </w-tag>
  </div>
</template>

<script>
import { groupStore } from "../store/label-group";
export default {
  name: "LabelsScroll",

  setup: (props, { emit }) => {
    // let labels = ref(props.allLabels);
    function setLabel(label) {
      emit("setlabel", label);
    }
    return { groupStore, setLabel };
  },
};
</script>
<style scoped>
.labels-container {
  display: flex;
  flex-wrap: wrap;
  max-height: 150px;
  overflow-y: auto;
  overflow-x: hidden;
  gap: 8px;
  padding: 2px;
  box-sizing: border-box;
}

.label-item {
  flex: 1 1 calc(20% - 8px);
  min-width: 140px;
  text-align: center;
  box-sizing: border-box;
  font-family: 'Robot', monospace;
}

</style>
